<template>
    <div>
        <b-card>
            <b-row class="course-listing-table-dropdown mb-2">
                <b-col cols="4">
                    <div class="left-image">
                        <img
                                :src="rowData.course_properties.imgUrl"
                        />
                    </div>
                </b-col>
                <b-col cols="8">
                    <h5 class="heading">{{ rowData.name }}</h5>
                    <div class="course-detail-summary">
                        <div class="course-detail-summary-item"><p>Subject : {{ rowData.course_properties.Subject }}</p>
                        </div>
                        <div class="course-detail-summary-item"><p>Price : ₹ {{ rowData.price }}</p></div>
                        <div class="course-detail-summary-item"><p>Category : {{ rowData.category_name }}</p></div>
                    </div>
                    <div class="three-button-holder">
                        <b-btn @click="$bvModal.show('confirmation-modal')">
                            <div class="co">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </div>
                            <span>Delete</span>
                        </b-btn>
                        <b-btn @click="editCourse">
                            <div class="co">
                                <font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
                            </div>
                            <span>Edit</span>
                        </b-btn>
                        <b-btn @click="viewMore">
                            <div class="co">
                                <font-awesome-icon :icon="['far', 'file-alt']"></font-awesome-icon>
                            </div>
                            <span>More details</span>
                        </b-btn>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal id="confirmation-modal" hide-footer>
            <template v-slot:modal-title>
                Delete <b>{{ rowData.name }}</b> Course
            </template>
            <div class="d-block text-center">
                <p>Are you sure you want to delete this course ?? </p>
            </div>
            <div class="row">
                <b-button class="col m-3"
                          variant="outline-primary" block
                          @click="$bvModal.hide('confirmation-modal')"
                >
                    Cancel
                </b-button>
                <b-button class="col m-3"
                          variant="outline-danger" block
                          @click="deleteCourse"
                >
                    Sure
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {courseEntityApi} from "../../services/adminApis/CourseEntityApi";
    import {liveCourseEntity} from "../../services/adminApis/liveCourseEntityApi";
    import {customerApi} from "../../services/customerApi";

    export default {
        name: "show-more",
        methods: {
            async deleteCourse() {
                this.$bvModal.hide("confirmation-modal");
                if(this.courseType === 'regular'){
                    await courseEntityApi.deleteCourse(this.rowData.course_id);
                }
                if(this.courseType === 'live'){
                    await liveCourseEntity.deleteLiveCourse(this.rowData.course_id);
                }
                await customerApi.getTeacherCourses();
                this.$bvToast.toast(`Course Deleted successfully`, {
                    title: "Course Deletion",
                    autoHideDelay: 500,
                    appendToast: true,
                    toaster: "b-toaster-bottom-center"
                });
            },
            editCourse() {
                this.$router.push({
                    path: "/admin/add-course",
                    query: {
                        courseId: this.rowData.course_id,
                        courseType: this.courseType
                    }
                });
            },
            viewMore() {

            }
        },
        props: {
            rowData: {},
            courseType:String
        }
    }
</script>

<style scoped>

</style>
